module.exports = __webpack_public_path__ + "img/nishio.e4c6a3e3.png";